namespace RedBullMOBILE360.Sms {
    @Serenity.Decorators.registerClass()
    export class WhitelistImportDialog extends Serenity.PropertyDialog<any, any>  {
        private form: WhitelistImportForm;
        public IsDataImported: boolean = false;

        constructor() {
            super();
            this.form = new WhitelistImportForm(this.idPrefix);
        }

        protected getDialogTitle(): string {
            return "Import Numbers";
        }

        protected getDialogButtons() {
            let buttons = [];
            buttons.push({
                text: 'Import',
                cssClass: 'export-xlsx-button',
                click: () => {
                    if (!this.validateBeforeSave())
                        return;

                    if (this.form.FileName.value == null ||
                        Q.isEmptyOrNull(this.form.FileName.value.Filename)) {
                        Q.notifyError("Please select a file!");
                        return;
                    }

                    WhiteListService.ExcelImport({
                        FileName: this.form.FileName.value.Filename,
                        ListName: this.form.ListName.value
                    }, (response) => {
                        let messageParts = new Array<string>();
                        if (response.Inserted > 0) messageParts.push("Message sent successfully");
                        if (response.Updated > 0) messageParts.push("<span style='color: red;'>Failed to send") + "</span>";
                        response.ErrorList.forEach((val) => {
                            messageParts.push(val);
                        });

                        let message: string = messageParts.join(", ");

                        if (response.Inserted > 0) {
                            Q.success(message, () => {
                            }, {
                                htmlEncode: false
                            });
                        }
                        else if (response.Updated > 0) {
                            Q.warning(message,
                                {
                                    htmlEncode: false
                                });
                        } else {
                            Q.information(message, () => {
                            }, {
                                htmlEncode: false
                            });
                        }

                        this.IsDataImported = true;

                        this.dialogClose();
                    });
                },
            });
            buttons.push(
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            );
            return buttons;
        }


    }
}